import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { CreditosModel, DeudaACortoPlazoCreditosModel } from './creditos.model';
import { CreditosListComponent } from './creditos-list.component';
import { CreditosService } from './creditos.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-creditosdeudaacortoplazo',
    templateUrl: './creditos-dialog-deuda-a-corto-plazo.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})
export class CreditosDialogDeudaACortoPlazoComponent implements OnInit {

  public creditos: CreditosModel = this.data.creditos;

  public deudaACortoPlazoCreditos: DeudaACortoPlazoCreditosModel = new DeudaACortoPlazoCreditosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public dataSource: DeudaACortoPlazoCreditosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'concepto', title: 'Concepto', cell: (row) => `${row.concepto}  `, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporte: boolean = false;

  public activities: ActivityModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreditosListComponent>,
    public creditosService: CreditosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
  ) { }

  public ngOnInit(): void {
    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

    this.getData();
  }

  public pay(): void {
    // Asignamos el uid de la inversion al deposito
    this.deudaACortoPlazoCreditos.creditosId = this.creditos.uid;

    let noError: boolean = true;

    // Validations
    if (this.deudaACortoPlazoCreditos.fecha == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.deudaACortoPlazoCreditos.concepto == null || this.deudaACortoPlazoCreditos.concepto == '') {
      noError = false;
      this.invalidConcept = true;
    }

    if (this.deudaACortoPlazoCreditos.importe == null || this.deudaACortoPlazoCreditos.importe == 0) {
      noError = false;
      this.invalidImporte = true;
    }

    if (this.deudaACortoPlazoCreditos.activitiesUid == null) {
      noError = false;
    }

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.creditosService.deudaACortoPlazoCreate(this.deudaACortoPlazoCreditos)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el elemento");
          });
      }
      if (this.isEditMode === true) {
        this.creditosService.deudaACortoPlazoUpdate(this.deudaACortoPlazoCreditos)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el elemento");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }

  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporte = false;

    this.creditosService.deudaACortoPlazoList(this.creditos.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    // Este uid es el id
    this.creditosService.deudaACortoPlazoDelete(uidElement)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar el elemento");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.depositSaved = false;

    this.deudaACortoPlazoCreditos = elementSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}
